var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a {\n                fill: #17bae0;\n            }\n\n            .b,\n            .c {\n                fill: none;\n            }\n\n            .c {\n                stroke: #fff;\n                stroke-linecap: round;\n                stroke-width: 2px;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.26 -0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(0.26 0.5)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H24V24H0Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.259 5.5)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "c",
    y2: 14,
    transform: "translate(7)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    y2: 14,
    transform: "translate(14 7) rotate(90)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.91f4e97cec000b34bdc95bd41e350600.svg";
export { ForwardRef as ReactComponent };